import { useRouter } from "vue-router";
import { watch, onBeforeUnmount } from "vue";

// Store for popstate event handlers (for nested modals)
// Initialized once after app starts
const handlers = [];

export default function useModalNavigation(props, emit, closeCb = null) {
  const router = useRouter();

  // To identify non-browser back redirect
  // to remove dummy history state
  let isFromBrowserBack = false;

  function closeModal() {
    if (closeCb) {
      closeCb();
    } else {
      emit("update:isOpen", false);
    }
  }

  function onPopState() {
    closeModal();
    isFromBrowserBack = true;
  }

  onBeforeUnmount(() => {
    window.removeEventListener("popstate", onPopState);
    document.body.style.overflow = "auto";
  });

  watch(
    () => props.isOpen,
    (val) => {
      window.removeEventListener("popstate", onPopState);

      // Disable scroll when open
      document.body.style.overflow = val ? "hidden" : "auto";
      if (val) {
        // Identify nested popstate events
        if (handlers.length > 0) {
          // Clear unneccessary events
          window.removeEventListener("popstate", handlers[handlers.length - 1]);
        }
        handlers.push(onPopState);

        // Add popstate to every open modal
        window.addEventListener("popstate", onPopState);

        // Add dummy history state for proper browser back redirect
        history.pushState("modal-open", null, "");
        return;
      }

      // Clear dummy history state
      // if modal was closed by non-browser action
      if (!isFromBrowserBack) {
        router.back();
      }

      setTimeout(() => {
        // Reinit cleared events
        handlers.pop();
        window.addEventListener("popstate", handlers[handlers.length - 1]);
        isFromBrowserBack = false;
      }, 100);
    }
  );

  return {
    closeModal,
  };
}
